module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "activation-info__wrapper"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "activation-info__content"
  }, [_c('h4', {
    staticClass: "info-title"
  }, [_vm._v(_vm._s(_vm.$t('PACKAGE_FOR_YOURSELF')))]), _vm._v(" "), _c('div', {
    staticClass: "info-box__wrapper"
  }, [_c('div', {
    staticClass: "info-box"
  }, [_c('h5', {
    staticClass: "info-box__title"
  }, [_vm._v("01")]), _vm._v(" "), _c('p', {
    staticClass: "info-box__text"
  }, [_vm._v(_vm._s(_vm.$t('ACTIVATE_HERE_OR')))])]), _vm._v(" "), _c('div', {
    staticClass: "info-box"
  }, [_c('h5', {
    staticClass: "info-box__title"
  }, [_vm._v("02")]), _vm._v(" "), _c('p', {
    staticClass: "info-box__text"
  }, [_vm._v(_vm._s(_vm.$t('AFTER_ACTIVATION')))])])]), _vm._v(" "), _c('h4', {
    staticClass: "info-title"
  }, [_vm._v(_vm._s(_vm.$t('PACKAGE_FOR_WOMAN')))]), _vm._v(" "), _c('div', {
    staticClass: "info-box__wrapper"
  }, [_c('div', {
    staticClass: "info-box"
  }, [_c('h5', {
    staticClass: "info-box__title"
  }, [_vm._v("01")]), _vm._v(" "), _c('p', {
    staticClass: "info-box__text"
  }, [_vm._v(_vm._s(_vm.$t('SEND_HER_CODE')))])]), _vm._v(" "), _c('div', {
    staticClass: "info-box"
  }, [_c('h5', {
    staticClass: "info-box__title"
  }, [_vm._v("02")]), _vm._v(" "), _c('p', {
    staticClass: "info-box__text"
  }, [_vm._v(_vm._s(_vm.$t('TELL_HER')))])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a41c420","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/activation-codes/activation-info.vue
// module id = 1192
// module chunks = 0